import { Link } from '@mui/material';
import { Stack } from '@mui/system';
import { GWPElement } from './GWPElement';
import { MgSupplierItemClimate } from '@retail/products/types';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  data: MgSupplierItemClimate['data'];
}

export const EpdContent = ({ data }: Props) => {
  const t = useProductsTFunction();

  return (
    <Stack display="grid" gridTemplateColumns="0.4fr 1fr">
      <GWPElement
        title={t('products.mgItem.gwp.epdOwner')}
        value={data.epdMetaData?.epdOwner ?? '-'}
      />

      <GWPElement
        title={t('products.mgItem.gwp.epdStandard')}
        value={data.epdMetaData?.epdStandard ?? '-'}
      />

      <GWPElement
        title={t('products.mgItem.gwp.epdDocumentation')}
        value={
          <Link
            href={data.epdMetaData?.epdAssetLink ?? ''}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('products.mgItem.gwp.viewEpd')}
          </Link>
        }
      />
    </Stack>
  );
};
